import type { NavigationCategory } from '@/lib/use-layout-config';

const STRICT_NAVIGATION_UTILITY_PATHS = [
  '/today',
  '/om',
  '/work-surface',
  '/e/customers',
  '/scm/customers',
];

function pathMatchesPrefix(pathname: string, prefix: string): boolean {
  const normalizedPrefix = prefix.split('?')[0]?.replace(/\/+$/, '') || prefix;
  if (!normalizedPrefix) return false;
  return pathname === normalizedPrefix || pathname.startsWith(`${normalizedPrefix}/`);
}

export function isStrictNavigationUtilityPath(pathname: string): boolean {
  return STRICT_NAVIGATION_UTILITY_PATHS.some((prefix) => pathMatchesPrefix(pathname, prefix));
}

export function isPathAllowedByStrictNavigation(pathname: string, navigation: NavigationCategory[]): boolean {
  if (isStrictNavigationUtilityPath(pathname)) return true;

  return navigation.some((category) => {
    const runtime = category.dynamicRuntime;
    if (runtime) {
      if (pathMatchesPrefix(pathname, runtime.defaultRoute)) return true;
      if (runtime.routePrefixes.some((prefix) => pathMatchesPrefix(pathname, prefix))) return true;
      if (runtime.aliases?.some((alias) => (
        pathMatchesPrefix(pathname, alias.browserRoute)
        || (alias.runtimeRoute ? pathMatchesPrefix(pathname, alias.runtimeRoute) : false)
      ))) return true;
    }
    return category.items.some((item) => {
      const route = item.route.split('?')[0] ?? item.route;
      return pathname === route || pathname.startsWith(`${route}/`);
    });
  });
}
